import './index_web.css';
import { View, Text, AddCashModal } from '../../../component';
import { getRealBalanceObj, isMatchInScheduled } from '../../../utilities/helper';
import useGame from '../../../utilities/hooks/game';
import useTheme from '../../../utilities/hooks/theme';
import I18n from '../../../utilities/locale';
import { ContestConfirmModal } from '../../component';
import TeamBox from '../../component/team_box/index_web';
import { useLink } from 'react-router-stack';
import { BsCheckSquareFill, BsSquare } from 'react-icons/bs';
import Button from '@mui/material/Button/Button';
import DefaultContainer from '../../../container/default_container';
import Constants from '../../../constants';
import { CounterWrapper } from '../../../component/header_with_timer';

const MyTeamsListWeb = ({
  matchItem,
  selectAll,
  gameType,
  myTeamList,
  selectTeamByUser,
  onPressPreview,
  onPressClone,
  onPressEdit,
  onPressAlreadyJoin,
  lineupsOut,
  title,
  matchAllPlayersList,
  contestTeams,
  tabType,
  onPressAddTeam,
  onPressJoinContest,
  totalTeamsCount,
  selectedTeamIdList,
  isTeamSwitch,
  contestConfirmModal,
  addCashVisible,
  joinContest,
  bonusPercentage,
  setContestConfirmModal,
  onPressDismissCashModal,
  onPressSelectAll
}: any) => {
  const { FantasyTheme: theme } = useTheme();
  const navigate = useLink();
  const { balanceInfo = {} } = useGame();

  const balance = getRealBalanceObj(balanceInfo);

  const { maxTeamPerUser = 1, contest = {} } = matchItem;

  const { entryFee = 0 } = contest;

  const switchTeamColor: any = {
    backgroundColor: '#F6D03F',
    color: '#111934'
    // border: '1px solid #ffd000'
  };

  const disableBtn = {
    color: theme.myTeamJoinContestDisableBtnText,
    backgroundColor: theme.myTeamJoinContestDisableBtn
  };

  const renderHeader = (matchItem: any, onCalledDeadline: any, gameType: any) => {
    const { ComponentTheme } = useTheme();

    const {
      teamA = {},
      teamB = {},
      status: matchStatus,
      verified,
      gameState = 0,
      matchDelayed = false
    } = matchItem;

    const matchTitleTextColor = {
      color: ComponentTheme.headerTitle
    };

    const isMatchScheduled = isMatchInScheduled({
      matchStatus,
      gameState,
      matchDelayed,
      gameType
    });

    const timerIconDimension = '20px';

    return (
      <>
        <div className="fantasy-cricket-header-with-timer-wrapper">
          <View className="fantasy_cricket_header_timer_wrapper" style={{ width: '30%' }}>
            {isMatchScheduled && (
              <View className="header-with-timer-icon-wrapper">
                <Constants.Svgs.Timer width={timerIconDimension} height={timerIconDimension} />
              </View>
            )}
            {
              <CounterWrapper
                onCalledDeadline={onCalledDeadline}
                matchStatus={matchStatus}
                verified={verified}
                matchItem={matchItem}
                isMatchScheduled={isMatchScheduled}
                gameType={gameType}
              />
            }
          </View>
          <div style={{ width: '50%' }}>
            <Text style={matchTitleTextColor} className="fantasy-cricketheader-with-timer-title">
              {`${teamA?.name} vs  ${teamB?.name}`}
            </Text>
          </div>
          <div style={{ width: '20%' }}>
            {!isTeamSwitch && maxTeamPerUser > 1 && (
              <View className={'my-team-list-select-all-container'} onPress={onPressSelectAll}>
                {selectAll ? (
                  <BsCheckSquareFill size={'20px'} fill={theme.myTeamSelectAllBtn} />
                ) : (
                  <BsSquare size={'20px'} fill={theme.myTeamSelectAllBtn} />
                )}
                <Text
                  className={'my-team-list-select-all'}
                  style={{
                    color: '#fff'
                  }}>
                  {'Select All'}
                </Text>
              </View>
            )}
          </div>
        </div>
      </>
    );
  };

  const onCalledDeadline = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const createTeamBtnStyle = {
    border: `2px solid ${theme.createTeamPreviewBtnLabel}`,
    backgroundColor: theme.createTeamPreviewBtn,
    color: theme.createTeamPreviewBtnLabel,
    marginTop: '15px'
  };
  const btnWrapperStyle = {
    background: theme.myTeamsBtnWrapperBg
  };
  return (
    <DefaultContainer>
      <View className="my-team-list-container">
        <div>
          <div className="myTeamList__title__web">Select Teams to Join Contest</div>
          <div style={{ height: '50px' }}>
            {renderHeader(matchItem, onCalledDeadline, gameType)}
          </div>
          <div className="myTeamList__teams__container__web">
            {myTeamList.map((item: any, idx: any) => (
              <div key={idx}>
                <TeamBox
                  selectTeamByUser={selectTeamByUser}
                  joinedMatch={true}
                  item={item}
                  key={item.matchTeamId}
                  onPressPreview={onPressPreview}
                  onPressClone={onPressClone}
                  onPressEdit={onPressEdit}
                  onPressAlreadyJoin={onPressAlreadyJoin}
                  lineupsOut={lineupsOut}
                  title={title}
                  matchAllPlayersList={matchAllPlayersList}
                  contestTeams={contestTeams}
                  gameType={gameType}
                  tabType={tabType}
                />
              </div>
            ))}

            <ContestConfirmModal
              visible={contestConfirmModal}
              onPressDismiss={() => setContestConfirmModal(false)}
              entryFee={entryFee / 100}
              selectedTeamCount={selectedTeamIdList.length}
              joinContest={joinContest}
              bonusPercentage={bonusPercentage}
            />
            <AddCashModal
              totalAmount={balance['totalBalance']}
              visible={addCashVisible}
              onPressDismiss={onPressDismissCashModal}
            />
          </div>
        </div>
        <div className="myTeamList__joinContest__createTeam__btn__wrapper__web">
          <View
            className={'myTeamList__joinContest__createTeam__container'}
            style={btnWrapperStyle}>
            <Button
              className={'my-team-list-create-button'}
              onClick={onPressJoinContest}
              style={selectedTeamIdList.length > 0 ? switchTeamColor : disableBtn}
              disabled={selectedTeamIdList.length === 0 ? true : false}>
              {isTeamSwitch ? I18n.t('switchTeam') : I18n.t('joinContest')}
            </Button>
            {totalTeamsCount < 11 && (
              <Button
                className={'my-team-list-create-button'}
                onClick={onPressAddTeam}
                style={createTeamBtnStyle}>
                {I18n.t('createTeam')}
              </Button>
            )}
          </View>
        </div>
      </View>
    </DefaultContainer>
  );
};

export default MyTeamsListWeb;
